import React from 'react';
import TextField from 'material-ui/TextField';

const hideAutoFillColorStyle = {
    WebkitBoxShadow: '0 0 0 1000px #303030 inset',
    color: 'white'
};

const RenderTextField = ({ input, type,hintText,floatingLabelText, meta: { touched, error }, ...custom }) => (
  <TextField type={type}
    hintText={hintText}
    floatingLabelText={floatingLabelText}
    errorText={touched && error}
    inputStyle={hideAutoFillColorStyle}
    {...input}
    {...custom}
  />
)

export default RenderTextField



/** WEBPACK FOOTER **
 ** ./src/components/CustomFields.js
 **/